import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
import { MultiSelect } from 'primereact/multiselect';


import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $contIdSeq: Int!

  ) {
    tbl_cont_season_def(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        cont_id: { _eq: $contIdSeq }
        
      }
    ) {
      firm_main_code
      firm_sub_code
      id_seq
      cont_id
      season_id
      start_date
      end_date
      opt_1
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;







const UPDATE_PER_PER = gql`
mutation UpdateContPerPer(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String  
  $perPeriod: String
  $perId: Int
  $redIdSeq: Int
  $perPersent: Int
  


  
) {
  update_tbl_cont_per_per(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }         
      id_seq: { _eq: $redIdSeq }
      period: { _eq: $perPeriod }
      per_id: { _eq: $perId }
      
    },
    _set: {
      percent: $perPersent,
        
    }
  ) {
    affected_rows
  }
}
`;


const UPDATE_PER_PER_BIG = gql`
mutation UpdateContPerPerBig(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String  
  $redIdSeq: Int
  $perPerson: Int
  $perPersonType: String
  $perRedSupType: String
  $perRooms: String

  
) {
  update_tbl_cont_per_per(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }         
      id_seq: { _eq: $redIdSeq }
    
      
    },
    _set: {
       person: $perPerson,
       person_type: $perPersonType,
       red_sup_type: $perRedSupType,
       rooms: $perRooms,
        
    }
  ) {
    affected_rows
  }
}
`;

const INSERT_PER_PER = gql`
  mutation InsertContractPerPer(
    $redIdSeq: Int
    $firmMainCode: String
    $firmSubCode: String  
    $contIdSeq: Int  
    $perPeriod: String
    $perId: Int  
    $perRooms: String    
   
    $perPerson: Int
  $perPersonType: String
    $perRedSupType: String
    

   
  ) {
    insert_tbl_cont_per_per(
      objects: {
        id_seq: $redIdSeq ,
        firm_main_code: $firmMainCode,
        firm_sub_code:$firmSubCode,
        cont_id: $contIdSeq,   
        period: $perPeriod,
        per_id:  $perId,        
        person_type: $perPersonType,
        red_sup_type: $perRedSupType,
        rooms: $perRooms,
        
        person: $perPerson,

      }
    ) {
      affected_rows
    }
  }
`;






const GET_PER_PER = gql`
  query GetPerPer($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int,
                   $perPeriod: String,
                   $redIdSeq: Int,
                   
                   ) {
    tbl_cont_per_per(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode },
      cont_id: { _eq: $contIdSeq },
      id_seq: { _eq: $redIdSeq },
      period: { _eq: $perPeriod },
    }) {
      id_seq
      firm_main_code
      firm_sub_code
      cont_id
      period
      per_id
      percent
      person_type
      red_sup_type
      person
      rooms
    }
  }
`;

const GET_PERSON_TYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_RED_TYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_ROOM_TYPE2 = gql`
  query GetHtlRooms(
    $firmMainCode: String
    $firmSubCode: String
    $perPerson: Int
    
  ) {
    tbl_htl_room_type(order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
       
      }
    ) {
     
        firm_main_code
        firm_sub_code
        r_class_code
        r_type_code
        r_type_name
        min_adl
        max_adl
        min_chl
        max_chl
        active
    }
  }
`;

const GET_ROOM_TYPE_old = gql`
  query GetHtlRooms(
    $firmMainCode: String
    $firmSubCode: String
    $perPerson: Int
  ) {
    tbl_htl_room_type(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      min_adl
      max_adl
      min_chl
      max_chl
      active
    }
  }
`;


const GET_ROOM_TYPE = gql`
  query GetHtlRooms(
    $firmMainCode: String
    $firmSubCode: String
    $perPerson: Int
  ) {
    tbl_htl_room_type(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        _and: [
          { max_adl: { _gte: $perPerson } },
          { min_adl: { _lte: $perPerson } }
        ]
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      min_adl
      max_adl
      min_chl
      max_chl
      active
    }
  }
`;

const GET_ROOM_TYPEC = gql`
  query GetHtlRooms(
    $firmMainCode: String
    $firmSubCode: String
    $perPerson: Int
  ) {
    tbl_htl_room_type(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        _and: [
          { max_chl: { _gte: $perPerson } },
          { min_chl: { _lte: $perPerson } }
        ]
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      min_adl
      max_adl
      min_chl
      max_chl
      active
    }
  }
`;




const INSERT_PER_GRP = gql`
  mutation InsertContractPerGrp(
    $redIdSeq: Int   
    $perRooms: String  
    $perId: Int  
    $contIdSeq: Int   

   
  ) {
    insert_tbl_cont_per_grp(
      objects: {
        id_seq: $redIdSeq ,       
        rooms: $perRooms,
        per_id: $perId,
        cont_id: $contIdSeq,

      

      }
    ) {
      affected_rows
    }
  }
`;
















const HtlAgnReductionEdit = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);

    const [someCondition, setSomeCondition] = useState(false);
    const [redIdSeq2] = useState(2862);
    const [perPeriod2, setPerPeriod2] = useState("G");

   

    
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
 
  
  
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4 },
    });

    const { loading: contPerPeLoading, error: contPerPeError, data: contPerPeraData, refetch: refetchUpdaate } = useQuery(GET_PER_PER, {
      variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: varCode4, redIdSeq: varCode5, perPeriod: varCode6 },
    });

    const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_PERSON_TYPE, {
        variables: { drbtype: "PTYP", lang: currentLocale },
      });

      const { loading: erdLoading, error: redError, data: redData } = useQuery(GET_RED_TYPE, {
        variables: { drbtype: "RSTYP", lang: currentLocale },
      });

     
  
    const ownFirmMainCode = firmcode;
    const ownFirmSubCode = subfirmcode;
    const ownFirmSubType = usertype;
  
   // const [UpdateContract] = useMutation(UPDATE_CONT);
    const [InsertContractPerPer] = useMutation(INSERT_PER_PER);
    const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2);   
    const [UpdateContPerPer] = useMutation(UPDATE_PER_PER);
    const [UpdateContPerPerBig] = useMutation(UPDATE_PER_PER_BIG);
    const [InsertContractPerGrp] = useMutation(INSERT_PER_GRP);

    



    // useMutation'ı bileşen içinde kullanın
    
    
  
  
    const firmData = data && data.tbl_cont_season_def ? data.tbl_cont_season_def[0] : null;

    const firmData2 = contPerPeraData && contPerPeraData.tbl_cont_per_per ? contPerPeraData.tbl_cont_per_per[0] : null;
    
   

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.id_seq :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.season_id :"");
    

 

   

    const [perPeriod, setPerPeriod] = useState(firmData2 ? firmData2.period :"");
    const [perId, setPerId] = useState(firmData2 ? firmData2.per_id :"");
    const [redIdSeq, setRedIdSeq] = useState(firmData2 ? firmData2.id_seq :"");    
    const [perPersent, setPerPersent] = useState(firmData2 ? firmData2.percent :"");
    const [perPerson, setPerPerson] = useState(firmData2 ? firmData2.person : '');
    const [perPersonType, setPerPersonType] = useState(firmData2 ? firmData2.person_type :"");
    const [perRedSupType, setPerRedSupType] = useState(firmData2 ? firmData2.red_sup_type :"");
    const [perRooms, setPerRooms] = useState(firmData2 ? firmData2.rooms :null);
    const [redIdSeq3, setRedIdSeq3] = useState("");   


   

    const { loading: bedLoading, error: bedError, data: bedAData } = useQuery(GET_ROOM_TYPE, {
        variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, perPerson: perPerson, perPersonType: perPersonType },
      });
      const { loading: bedCLoading, error: bedCError, data: bedCData } = useQuery(GET_ROOM_TYPEC, {
        variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, perPerson: perPerson, perPersonType: perPersonType },
      });


     



     

  const handlePerPereUpdate = () => {
    UpdateContPerPer({
      variables: {
        contIdSeq: contIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        perPeriod: perPeriod,
        redIdSeq: redIdSeq,
        perPersent: perPersent,
        perId: perId,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetchUpdaate();

      
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  }; 

  const handlePerPereUpdateBig = () => {
    UpdateContPerPerBig({
      variables: {
        contIdSeq: contIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        redIdSeq: redIdSeq,        
        perRooms: perRooms.join(','),
        perPerson: perPerson,
        perPersonType:perPersonType,
        perRedSupType: perRedSupType,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetchUpdaate();

      
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  }; 



  const handlePerPerinsert = () => {
    InsertContractPerPer({
     variables: {
      contIdSeq: contIdSeq,
      firmMainCode: firmMainCode,
      firmSubCode: firmSubCode,
      perPeriod: "NO",
      redIdSeq: redIdSeq,      
      perId: 88,
      perPerson: perPerson,
      perRedSupType: perRedSupType,
      perPersonType: perPersonType,
      perRooms: perRooms.join(','),





      
      
     },
   })
     .then(() => {
       window.alert("Contract Season insert successfully!");
       
    
     })
     .catch((error) => {
       console.error("Error insert cont Season:", error);
       console.error('Mutation error:', error);
       console.error('Extra error information:', error.graphQLErrors, error.networkError);
       
     });
 };

 const handlePerPerinsertGrp = () => {
    // perRooms'un bir dizi olup olmadığını kontrol et
    if (Array.isArray(perRooms)) {
      perRooms.forEach((room) => {
        InsertContractPerGrp({
          variables: {
            redIdSeq: redIdSeq,
            perRooms: room,
            contIdSeq: contIdSeq,
            perId: perId,
          },
        })
          .then(() => {
            console.log(`Contract Season for room ${room} inserted successfully!`);
          })
          .catch((error) => {
            console.error(`Error inserting Contract Season for room ${room}:`, error);
            console.error('Mutation error:', error);
            console.error('Extra error information:', error.graphQLErrors, error.networkError);
          });
      });
    } else {
      console.error("perRooms is not an array!", perRooms);
      // İsterseniz burada başka bir şey yapabilirsiniz
    }
  };
  

  useEffect(() => {
    
    refetchUpdaate();  
   
    console.log('Sayfa açıldı!');
    
    // componentWillUnmount
    return () => {
      console.log('Sayfa kapatılıyor...');
      refetchUpdaate();  
     
    };
  }, []);

      useEffect(() => {
        if (firmData2) {  

          //  console.log("firmData2.rooms:", firmData2.rooms);
            
          setRedIdSeq(firmData2.id_seq);
          setPerPerson(firmData2.person);
          setPerPeriod(firmData2.period);
          setPerPersent(firmData2.percent);
          setPerPersonType(firmData2.person_type);
          setPerRedSupType(firmData2.red_sup_type);
          setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.season_id);
          setPerId(firmData2.per_id);


          const roomsArray = Array.isArray(firmData2.rooms) ? firmData2.rooms : firmData2.rooms.split(',');
          setPerRooms(roomsArray);
             
    
        }
      }, [firmData2]);


      const onUpdateButtonClick = (rowData) => {
      
        handlePerPereUpdate();
        handlePerPereUpdateBig();
    
       };

      const onEditButtonClick = (rowData) => {
       
       handleUpdateIdSeq();
       
      };


     
      useEffect(() => {
       
        if (redIdSeq3 !== '') {
          
          handlePerPerinsert();  
        
        }
      }, [redIdSeq3]);


      const handleUpdateIdSeq2 = async () => {
        try {
          const { data } = await updateIdSeq2({
            variables: {
              type: 'MFIRM', 
            },
          });
          const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
          console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
          setRedIdSeq(updatedIdSeq); 
          setPerRedSupType(updatedIdSeq); 
          
          
         
         // setVarCode(updatedIdSeq.toString());  
          console.log(contSeaIdSeq);         
           
          
        } catch (error) {
          console.error('Güncelleme hatası:', error);
        }
      };


      const handleUpdateIdSeq = async () => {
        const requiredFields = ['perPersonType' ]; // Required fiels
        const customFieldNames = {
            perPersonType: "Hotel Sezon Kodu"
        
    
        };
        const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
      
        if (emptyFields.length === 0) {
          try {
            const { data } = await updateIdSeq2({
              variables: {
                type: 'MFIRM', 
              },
            });
            const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
            console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
            setRedIdSeq(updatedIdSeq); 
            setRedIdSeq3(updatedIdSeq); 
            
            console.log(contSeaIdSeq);
            // setVarCode(updatedIdSeq.toString());  
          } catch (error) {
            console.error('Güncelleme hatası:', error);
          }
        } else {
          
          const emptyFieldsMessage = `Lütfen Hotel Sezonu doldurun: ${emptyFields.join(', ')}`;
         // console.log(emptyFieldsMessage);
          window.alert(emptyFieldsMessage);
        }
      };
      
      const validateForm = (requiredFields, customFieldNames) => {
        // Tüm gerekli alanları kontrol et
        for (const field of requiredFields) {
          if (!eval(field)) {
            return false;
          }
        }
      
        return true;
      };
      
      const getEmptyFields = (requiredFields, customFieldNames) => {
        const emptyFields = [];
      
        // Boş olan alanları bul
        for (const field of requiredFields) {
          if (!eval(field)) {
            emptyFields.push(customFieldNames[field]);
          }
        }
      
        return emptyFields;
      };


      const personSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const redSelectItemsB = redData && redData.tbl_gnl_def
  ? redData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];




  const bedSelectItemsB = 
  (perPersonType === 'A' && bedAData && bedAData.tbl_htl_room_type) ?
    bedAData.tbl_htl_room_type.map(item => ({
      label: item.r_type_name,
      value: item.r_type_code,
      name: item.r_type_name, 
    })) :
  (perPersonType === 'C' && bedCData && bedCData.tbl_htl_room_type) ?
    bedCData.tbl_htl_room_type.map(item => ({
      label: item.r_type_name,
      value: item.r_type_code,
      name: item.r_type_name, 
    })) :
  [];
    

  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
  
    return (
        <>
         <div>
         <div className="flex">             
             
  
         <div className="w-2/12 h-3 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full h-3" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {"red sup type"}</label>
        <InputText className="w-full h-11 " 
        id="firmname" value={perRedSupType} 
        onChange={(e) => setPerRedSupType(e.target.value)} />
      </div>

      <div className="w-1/8 pl-2">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"room_bed_type_title"}
    </label>
    <Dropdown
      className="w-full h-11 rounded-md"
      value={perRedSupType}
      options={redSelectItemsB}
      onChange={(e) => setPerRedSupType(e.value)}
      placeholder={"select_a_Calc_type"}
    />
   </div>           
 
              </div>


              

              
              <div className="flex flex-wrap mt-4">
              <div className="mr-2 w-20 flex-auto">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"person"}
                </label>
                <InputNumber
                  inputId="integeronly"
                   
                  useGrouping={false}
                  value={perPerson}
                  onValueChange={(e) => setPerPerson(e.value)}
                  className="w-full text-end border focus:ring-violet-800 focus:border-violet-800 block  rounded-md border-gray-400"
               
                  
                  
                
                  
                />                
              </div>
              <div className="w-20 h-3 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full h-3" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {"Type"}</label>
        <InputText className="w-full h-11 " 
        id="firmname" value={perPersonType} 
        onChange={(e) => setPerPersonType(e.target.value)} />
      </div>

      <div className="w-1/8 pl-2">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"Person Type"}
    </label>
    <Dropdown
      className="w-full h-11 rounded-md focus:ring-violet-800 focus:border-violet-800 block  border-gray-400"
      value={perPersonType}
      options={personSelectItemsB}
      onChange={(e) => setPerPersonType(e.value)}
      placeholder={"select_a_Person_type"}
    />
  </div>         

      


      <div className="ml-2  w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Persent %"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  prefix="%"
                  useGrouping={false}
                  value={perPersent}
                  onValueChange={(e) => setPerPersent(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  
                />                
              </div>
            
          </div>

          <div className="w-4/3 pl-2">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"Person Type"}
    </label>
    <MultiSelect
    display="chip"
      className="w-full h-11 rounded-md focus:ring-violet-800 focus:border-violet-800 block  border-gray-400"
      value={Array.isArray(perRooms) ? perRooms : []}
      options={bedSelectItemsB}
      onChange={(e) => setPerRooms(e.value)}
      placeholder={"select_bed_types"}
      style={{ width: '100%' }}
    />
  </div>  

          <div className="mt-4 flex">
<div className="mr-2 w-1/4">
  <label htmlFor="firmType" className="block font-medium text-gray-700">
    {"Rooms"}
  </label>
  <InputText className="w-full h-11 " 
    id="rooms"    
    value={perRooms}
    onChange={(e) => setPerRooms(e.target.value)}
   
    
  />                
</div>


    


 


</div>
         

          <div className="flex mt-4 ">


    <div className="mr-2 w-1/8">
          <label htmlFor="firmType" className="block font-medium text-gray-700">
            {"Persent Id"}
          </label>
          <InputNumber
            inputId="integeronly"
            useGrouping={false}
            value={redIdSeq}
            onValueChange={(e) => setRedIdSeq(e.value)}
            className="w-full h-11 border-gray-300 rounded-md"
            
          />                
        </div>

         <div className="mr-2 w-1/8">
          <label htmlFor="firmType" className="block font-medium text-gray-700">
            {"Cont Id"}
          </label>
          <InputNumber
            inputId="integeronly"
            useGrouping={false}
            value={contSeaIdSeq}
            onValueChange={(e) => setContSeaIdSeq(e.value)}
            className="w-full h-11 border-gray-300 rounded-md"
            
          />                
        </div>

        <div className="w-2/12 h-3 p-inputtext-sm flex-column gap-3">
  <label styleClass="w-full h-3" className="block  font-medium text-gray-950 justify-content-center gap-4"
   htmlFor="firmname"> {"period"}</label>
  <InputText className="w-full h-11 " 
  id="firmname" value={perPeriod} 
  onChange={(e) => setPerPeriod(e.target.value)} />
</div>
    <Button label="New" onClick={onEditButtonClick} />
    <Button label="Update" onClick={onUpdateButtonClick} />
    <button onClick={handlePerPerinsertGrp}>Insert Rooms</button>
    </div>     
          </div>    

        
        </>
      );
      
  };
  
  export default HtlAgnReductionEdit;

 

      
  